export default __webpack_public_path__ + "static/media/logo-funtrab.074f495a.png";